import { IPlaylist, IVideo } from '../interfaces/youtube';
import { youtubeApi } from '../youtubeApi';

export const getPlaylistItems = async () => {
  const url = `${youtubeApi.youtubeDefaultUrl}/playlistItems?part=snippet,contentDetails,status&playlistId=${youtubeApi.playlistId}&key=${youtubeApi.apiKey}`;
  const options = {
    headers: {
      'Content-Type': 'application/json',
    },
  };

  try {
    const response = await fetch(url, options);
    if (!response.ok) {
      throw new Error(`Error: ${response.status} ${response.statusText}`);
    }
    const data = await response.json();
    return data as IPlaylist;
  } catch (error) {
    console.error('Failed to fetch playlist items:', error);
    throw new Error('Could not get playlist details');
  }
};

export const getVideoDetails = async (videoId: string) => {
  const url = `${youtubeApi.youtubeDefaultUrl}/videos?part=snippet,contentDetails,status,liveStreamingDetails&id=${videoId}&key=${youtubeApi.apiKey}`;
  const options = {
    headers: {
      'Content-Type': 'application/json',
    },
  };

  try {
    const response = await fetch(url, options);
    if (!response.ok) {
      throw new Error(`Error: ${response.status} ${response.statusText}`);
    }
    const data = await response.json();
    return data as IVideo;
  } catch (error) {
    console.error('Failed to fetch video item:', error);
    throw new Error('Could not get video details');
  }
};
